<div class="right-side p-5">
  <h2>Repository</h2>
  <div class="section">
    <form [formGroup]="form">
      <div class="card mb-3">
        <div class="card-header"> <h2>Repository Details</h2></div>
        <div class="card-body">
          <div class="row mb-3">
            <div class="col-md-4">
              <label class="nowrap">Intervention<span class="text-danger">*</span></label>
              <select id="txtIntervention" class="form-control" formControlName="Intervention" (change)="GetComponent($event, 'select')">
                <option value="" disabled selected>Select Intervention</option>
                <option *ngFor="let type of interventions" [value]="type.id">
                  {{ type.text }}
                </option>
              </select>
              <!-- Validation error messages -->
              <div *ngIf="f['Intervention'].touched && f['Intervention'].invalid" class="alert alert-danger required">
                <small class="error">Select at least 1 intervention</small>
              </div>
              <!--<div *ngIf="f['Intervention'].touched && f['Intervention'].invalid" class="alert alert-danger">
                <div *ngIf="f['Intervention'].errors?.['required']">
                  <small class="error">Select at least 1 intervention</small>
                </div>
              </div>-->
            </div>

            <div class="col-md-4">
              <label class="nowrap">Interests<span class="text-danger">*</span></label>
              <select id="txtInterests" class="form-control" formControlName="InterestsId">
                <option value="" disabled selected>Select Interest</option>
                <option *ngFor="let type of filteredInterests" [value]="type.id">
                  {{ type.text }}
                </option>
              </select>
              <div *ngIf="f['InterestsId'].touched && f['InterestsId'].invalid" class="alert alert-danger required">
                <small class="error">Select at least 1 interest.</small>
              </div>
              <!--<div *ngIf="f['InterestsId'].touched && f['InterestsId'].invalid" class="alert alert-danger">
                <div *ngIf="f['InterestsId'].errors?.['required']">
                  Select at least 1 interest
                </div>
              </div>-->
            </div>
          </div>
          <div class="row mt-2" *ngFor="let documentGroup of documents.controls; let i = index">
            <label class="text-danger me-2" for="document-{{ i }}">
              Document File (PDF, JPG, PNG, ZIP, MP4, AVI, MOV max 50 MB):<span class="text-danger">*</span>
            </label>
            <div class="col-md-6 mb-2">

              <input type="file"
                     class="form-control"
                     id="document-{{ i }}"
                     accept=".jpg, .jpeg, .png, .pdf, .zip, .mp4, .avi, .mov"
                     (change)="onDocumentFileChange($event, i)" />
              <!--Validation Messages-->
              <div *ngIf="documentGroup.get('documentFile')?.touched && documentGroup.get('documentFile')?.invalid">
                <div *ngIf="documentGroup.get('documentFile')?.errors?.['required']" class="alert alert-danger required">
                  <small class="error">Upload File is required.</small>

                </div>
                <div *ngIf="documentGroup.get('documentFile')?.errors?.['typeError']" class="alert alert-danger">
                  <small class="error">Invalid file type. Only PDF, JPG, PNG, and ZIP files are allowed.</small>
                </div>
                <div *ngIf="documentGroup.get('documentFile')?.errors?.['sizeError']" class="alert alert-danger">
                  <small class="error">File size should not exceed 50 MB.</small>
                </div>
              </div>
              <!-- Remove Button -->
              <button *ngIf="documents.length > 1" type="button" class="btn btn-danger btn-sm" (click)="removeDocument(i)">
                <i class="bi bi-trash"></i> Remove
              </button>


              <!--<div *ngIf="documentGroup.get('document')?.touched && documentGroup.get('document')?.invalid">
                <div *ngIf="documentGroup.get('document')?.errors?.['required']" class="text-danger">
                  Upload File is required.
                </div>
                <div *ngIf="documentGroup.get('document')?.errors?.['typeError']" class="text-danger">
                  Invalid file type. Only PDF, JPG, PNG, and ZIP files are allowed.
                </div>
                <div *ngIf="documentGroup.get('document')?.errors?.['sizeError']" class="text-danger">
                  File size should not exceed 10 MB.
                </div>
              </div>-->
              <!--<span class="text-danger me-2"  id="document-{{ i }}">{{ documentGroup.get('documentName')?.value }}</span>-->
            </div>
          </div>

          <div class="col-md-4 mt-3">
            <button type="button" class="btn btn-primary btn-sm" (click)="onAddNewDocument()"><i class="bi bi-plus-lg"></i> Add New Document</button>
          </div>
          <div class="text-center mt-3">
            <button id="btnSave" type="button" class="btn btn-success" (click)="onSubmit()"> {{ buttonText }} </button>
          </div>
        </div>
      </div>

    </form>
    <div class="card mb-3">
      <div class="card-header"><h2>Repository Table</h2></div>
      <div class="card-body">
        <form [formGroup]="form1">
          <div class="col-lg-7 col-sm-12">
            <div class="search-container">
              <mat-form-field class="search-input w-75" appearance="outline">
                <mat-label>Search</mat-label>
                <input matInput formControlName="searchControl" />
              </mat-form-field>
              <button class="btn btn-outline-secondary p-2 mx-1 search-button" type="submit" (click)="onSearchClick(form1.get('searchControl')?.value ?? '')" id="btnSearch">
                <i class="bi bi-search fs-4"></i>
              </button>
            </div>
            <div *ngIf="form1.get('searchControl')?.invalid && (form1.get('searchControl')?.touched)">
              <small *ngIf="form1.get('searchControl')?.errors?.['pattern']" class="text-danger">
                Invalid search term.
              </small>
            </div>
          </div>



          <!--<div class="table-responsive">
    <table class="table table-striped table-bordered table-hover">
      <thead>
        <tr>
          <th>Sr.No</th>

          <th class="text-center">Name</th>
          <th class="text-center">Intervention</th>
          <th class="text-center">Interest</th>
          <th class="text-center">Created Date</th>
          <th class="text-center">Document Name</th>-->
          <!--<th class="text-center">Action</th>-->
          <!--<th class="text-center">Download</th>

      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let gr of RepositoryDetailsData ; let i = index ">
        <td>{{ gr.rowNum  }}</td>
        <td class="text-center">{{ gr.iaUserName }}</td>
        <td class="text-center">{{ gr.interventionName }}</td>
        <td class="text-center">{{ gr.interestName }}</td>
        <td class="text-center">{{ gr.createdDate }}</td>
        <td class="text-center">{{ gr.documentName }}</td>-->
          <!--<td style="text-align:center">
      <span *ngIf="gr.id" (click)="onEdit(gr.id)" class="btn btn-primary btn-sm me-2"><i class="bi bi-pencil"></i> Edit</span>
    </td>-->
          <!--<td class="text-center">
              <a *ngIf="gr.documentPath"
                 (click)="onDownload(gr.documentPath, gr.documentName); $event.preventDefault()" style="cursor: pointer" class="btn btn-warning btn-sm">
                <i class="bi bi-download"></i> Download
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <mat-paginator #paginator
                   class="demo-paginator"
                   (page)="onPageChange($event)"
                   [length]="length"
                   [pageSize]="pageSize"
                   [disabled]="disabled"
                   [showFirstLastButtons]="showFirstLastButtons"
                   [pageSizeOptions]="pageSizeOptions"
                   [hidePageSize]="hidePageSize"
                   [pageIndex]="pageIndex"
                   aria-label="Select page">
    </mat-paginator>-->


          <div class="table-responsive">
            <table mat-table [dataSource]="RepositoryDetailsData" class="mat-elevation-z8 table table-striped table-bordered table-hover" matSort matSortActive="CreatedDate" matSortDirection="asc" matSortDisableClear>

              <!-- Sr. No Column -->
              <ng-container matColumnDef="SrNo">
                <th mat-header-cell *matHeaderCellDef> Sr. No. </th>
                <td mat-cell *matCellDef="let gr"> {{gr.rowNum}} </td>
              </ng-container>

              <!-- Name Column -->
              <ng-container matColumnDef="Name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
                <td mat-cell *matCellDef="let gr"> {{gr.iaUserName}} </td>
              </ng-container>

              <!-- Intervention Column -->
              <ng-container matColumnDef="Intervention">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Intervention </th>
                <td mat-cell *matCellDef="let gr"> {{gr.interventionName}} </td>
              </ng-container>

              <!-- Interest Column -->
              <ng-container matColumnDef="Interest">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Interest </th>
                <td mat-cell *matCellDef="let gr"> {{gr.interestName}} </td>
              </ng-container>

              <!-- Created Date Column -->
              <ng-container matColumnDef="CreatedDate">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Created Date </th>
                <td mat-cell *matCellDef="let gr"> {{gr.createdDate}} </td>
              </ng-container>

              <!-- Document Name Column -->
              <ng-container matColumnDef="DocumentName">
                <th mat-header-cell *matHeaderCellDef> Document Name </th>
                <td mat-cell *matCellDef="let gr"> {{gr.documentName}} </td>
              </ng-container>

              <!-- Download Column -->
              <ng-container matColumnDef="Download">
                <th mat-header-cell *matHeaderCellDef> Download </th>
                <td mat-cell *matCellDef="let gr">
                  <a *ngIf="gr.documentPath"
                     (click)="onDownload(gr.documentPath, gr.documentName); $event.preventDefault()"
                     style="cursor: pointer"
                     class="btn btn-warning btn-sm">
                    <i class="bi bi-download"></i> Download
                  </a>
                </td>
              </ng-container>

              <!-- Header Row -->
              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <!-- Data Row -->
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
              <!-- No Data Row -->
              <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="7">No data matching the filter</td>
              </tr>
            </table>
          </div>

          <!-- Paginator -->
          <mat-paginator #paginator
                         class="demo-paginator"
                         (page)="onPageChange($event)"
                         [length]="length"
                         [pageSize]="pageSize"
                         [showFirstLastButtons]="showFirstLastButtons"
                         [pageSizeOptions]="pageSizeOptions"
                         [hidePageSize]="hidePageSize"
                         [pageIndex]="pageIndex"
                         aria-label="Select page">
          </mat-paginator>


        </form>
      </div>
    </div>
  </div>
</div>
<!--<div class="right-side p-5">
  
  <div class="section">
   
  </div>
</div>-->




